import React, { useRef } from 'react';
import {
  renderData,
  renderXScale,
  renderTooltip,
  makeDatesListAndFormatters,
  calcSizes,
  renderRootSvg,
  renderYScale,
} from './helpers';

export const StatisticGraph = ({
  data,
  containerWidth,
  containerHeight,
  startDate,
  endDate,
}) => {
  const wrapperElement = useRef(null);

  if (wrapperElement.current) {
    const sizes = calcSizes(containerWidth, containerHeight);

    const svg = renderRootSvg(wrapperElement.current, sizes);

    const { datesList, formatFn, parseFn } = makeDatesListAndFormatters(
      startDate,
      endDate,
    );

    const { x } = renderXScale(svg, datesList, formatFn, sizes);

    const { y } = renderYScale(svg, data, sizes);

    const graph = renderData(
      svg,
      sizes,
      datesList,
      x,
      y,
      formatFn,
      parseFn,
      data,
    );

    renderTooltip(wrapperElement.current, sizes, data, parseFn, graph);
  }

  return <div ref={wrapperElement}></div>;
};
